import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=b18f9a80&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=b18f9a80&lang=scss&scoped=true&"
import style1 from "./TaskDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18f9a80",
  null
  
)

export default component.exports